import { Section } from "frno-react";
import DynamicText from "../common/DynamicText";

export default function NotFoundPage() {
  return (
    <Section mt={1}>
      <h2>
        <DynamicText textKey="page.error.header" />
      </h2>
      <p>
        <DynamicText textKey="page.error.content" />
      </p>
    </Section>
  );
}
